import { StatusIndicatorProps } from './StatusIndicator.model';
import { StatusLabels } from 'interfaces';
import { FlexRow, Text } from '@epam/promo';
import React from 'react';
import { StatusIndicatorDot } from './StatusIndicatorDot';

export const StatusIndicator = ({ size, status }: StatusIndicatorProps) => {
  if (!status) return null;

  return (
    <FlexRow size={null}>
      <StatusIndicatorDot size={size} status={status} />
      <Text
        color="gray80"
        rawProps={{
          'data-testid': 'status-indicator-text',
        }}
        size="24">
        {StatusLabels[status]}
      </Text>
    </FlexRow>
  );
};
